import { hasBoggleDevSearchFlag } from '~/boggle/devMode'
import { normalizeSeed } from '~/boggle/engine/core'

function readFirstSearchValue(value: unknown): unknown {
  return Array.isArray(value) ? value[0] : value
}

export function isBoggleDebugSearchEnabled(search: Record<string, unknown>) {
  return import.meta.env.DEV && hasBoggleDevSearchFlag(search.debug)
}

export function readBoggleDebugSeed(search: Record<string, unknown>) {
  const value = readFirstSearchValue(search.seed)

  if (typeof value === 'number' && Number.isFinite(value)) {
    return normalizeSeed(value)
  }

  if (typeof value !== 'string') {
    return null
  }

  const trimmed = value.trim()
  return trimmed.length > 0 ? normalizeSeed(trimmed) : null
}
